export const menuConstants = {
    GETALL_REQUEST: 'MENU_GETALL_REQUEST',
    GETALL_SUCCESS: 'MENU_GETALL_SUCCESS',
    GETALL_FAILURE: 'MENU_GETALL_FAILURE' 
};